// extracted by mini-css-extract-plugin
export var active = "_b8-7";
export var container = "_b8-0";
export var evenWidth = "_b8-4";
export var large = "_b8-5";
export var outlet = "_b8-8";
export var slide = "_b8-2";
export var small = "_b8-6";
export var tab = "_b8-3";
export var tabs = "_b8-1";